module.exports = __webpack_public_path__ + "img/se-annat.b5837f6c.png";